import { applyMiddleware, compose, createStore  }  from 'redux';
import createSagaMiddleware from 'redux-saga';
import reducers from '@/redux/reducers';
import rootSaga from '@/redux/sagas';

const sagaMiddleware = createSagaMiddleware(); 

let store: any;  
if(process.env.NODE_ENV === 'development') {
    if(( window as any ) && ( window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        store = createStore(reducers, compose(applyMiddleware(sagaMiddleware), (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()));
    } else {
        store = createStore(reducers, applyMiddleware(sagaMiddleware));
    }
} else {
    store = createStore(reducers, compose(applyMiddleware(sagaMiddleware)));
}

sagaMiddleware.run(rootSaga);

export default store;